import type { SortDescriptor } from "@progress/kendo-data-query";

export const getNextSort = (
  currentSort: SortDescriptor | undefined,
  field: string,
): SortDescriptor | undefined => {
  if (currentSort?.field !== field || !currentSort.dir) {
    return { field, dir: "asc" };
  }

  if (currentSort.dir === "asc") {
    return { field, dir: "desc" };
  }

  return undefined;
};

export const resolveInitialSort = (
  initialSort: SortDescriptor | null | undefined,
  defaultField: string,
): SortDescriptor | undefined => {
  if (initialSort === null) {
    return undefined;
  }

  return initialSort ?? { field: defaultField, dir: "asc" };
};
